export function truncateAddress(address: string, length: number = 4): string {
  return `${address.slice(0, 2 + length)} . . . ${address.slice(-length)}`;
}
